import restauranteAmbientes from "@/modules/Restaurante/pages/Ambientes/Index";
import restauranteAmbientesNovo from "@/modules/Restaurante/pages/Ambientes/Create";
import restauranteAmbientesEditar from "@/modules/Restaurante/pages/Ambientes/Update";
import restauranteMesas from "@/modules/Restaurante/pages/Mesas/Operacional";
import restauranteMesasCadastro from "@/modules/Restaurante/pages/Mesas/Index";
import restauranteMesasNovo from "@/modules/Restaurante/pages/Mesas/Create";
import restauranteMesasEditar from "@/modules/Restaurante/pages/Mesas/Update";
import restauranteProducao from "@/modules/Restaurante/pages/Producao/Index.vue";
import restauranteCheckout from "@/modules/Restaurante/pages/Checkout/Index.vue";
import restauranteBar from "@/modules/Restaurante/pages/Bar/Index.vue";
import restauranteCardapioOnline from "@/modules/Restaurante/pages/CardapioOnline/Index.vue";
import restaurantePedidosOnline from "@/modules/Restaurante/pages/PedidosOnline/Index.vue";
import restauranteEntregasOnline from "@/modules/Restaurante/pages/EntregasOnline/Index.vue";

export default [
  {
    name: "restauranteAmbientes",
    path: "/restauranteAmbientes",
    component: restauranteAmbientes,
    meta: { title: "Restaurante - Ambientes", permission: "restauranteAmbientes" },
  },
  {
    name: "restauranteAmbientesNovo",
    path: "/restauranteAmbientes/novo",
    component: restauranteAmbientesNovo,
    meta: { title: "Restaurante - Ambientes", permission: "restauranteAmbientes" },
  },
  {
    name: "restauranteAmbientesEditar",
    path: "/restauranteAmbientes/:id/editar",
    component: restauranteAmbientesEditar,
    meta: { title: "Restaurante - Ambientes", permission: "restauranteAmbientes" },
  },
  {
    name: "restauranteMesas",
    path: "/restauranteMesas",
    component: restauranteMesas,
    props: {
      perfilOperacional: "caixa",
      titulo: "Salão Restaurante",
      subtitulo: "Mesa, comanda, produção e fechamento em uma operação só",
      exibirCheckout: true,
    },
    meta: { title: "Restaurante - Mesas", permission: "restauranteCaixa" },
  },
  {
    name: "restauranteGarcom",
    path: "/restauranteGarcom",
    component: restauranteMesas,
    props: {
      perfilOperacional: "garcom",
      titulo: "Garçom",
      subtitulo: "Mesas, comandas e envio de pedidos para produção",
      exibirCheckout: false,
    },
    meta: { title: "Restaurante - Garçom", permission: "restauranteGarcom" },
  },
  {
    name: "restauranteCaixa",
    path: "/restauranteCaixa",
    component: restauranteMesas,
    props: {
      perfilOperacional: "caixa",
      titulo: "Caixa Restaurante",
      subtitulo: "Mesas, comandas, produção e fechamento de conta",
      exibirCheckout: true,
    },
    meta: { title: "Restaurante - Caixa", permission: "restauranteCaixa" },
  },
  {
    name: "restauranteMesasCadastro",
    path: "/restauranteMesas/cadastro",
    component: restauranteMesasCadastro,
    meta: { title: "Restaurante - Cadastro de Mesas", permission: "restauranteAmbientes" },
  },
  {
    name: "restauranteAmbientesMesas",
    path: "/restauranteAmbientes/:ambienteId/mesas",
    component: restauranteMesasCadastro,
    meta: { title: "Restaurante - Mesas do Ambiente", permission: "restauranteAmbientes" },
  },
  {
    name: "restauranteMesasNovo",
    path: "/restauranteMesas/novo",
    component: restauranteMesasNovo,
    meta: { title: "Restaurante - Mesas", permission: "restauranteAmbientes" },
  },
  {
    name: "restauranteAmbientesMesasNovo",
    path: "/restauranteAmbientes/:ambienteId/mesas/novo",
    component: restauranteMesasNovo,
    meta: { title: "Restaurante - Mesas do Ambiente", permission: "restauranteAmbientes" },
  },
  {
    name: "restauranteMesasEditar",
    path: "/restauranteMesas/:id/editar",
    component: restauranteMesasEditar,
    meta: { title: "Restaurante - Mesas", permission: "restauranteAmbientes" },
  },
  {
    name: "restauranteAmbientesMesasEditar",
    path: "/restauranteAmbientes/:ambienteId/mesas/:id/editar",
    component: restauranteMesasEditar,
    meta: { title: "Restaurante - Mesas do Ambiente", permission: "restauranteAmbientes" },
  },
  {
    name: "restauranteProducao",
    path: "/restauranteProducao",
    component: restauranteProducao,
    meta: { title: "Restaurante - Produção", permission: "restauranteCozinha" },
  },
  {
    name: "restauranteBar",
    path: "/restauranteBar",
    component: restauranteBar,
    meta: { title: "Restaurante - Bar", permission: "restauranteBar" },
  },
  {
    name: "restauranteCozinha",
    path: "/restauranteCozinha",
    component: restauranteProducao,
    props: {
      tipoProducao: "cozinha",
      titulo: "Cozinha",
      subtitulo: "Pedidos enviados para produção da cozinha",
      exibirMesasAtalho: false,
    },
    meta: { title: "Restaurante - Cozinha", permission: "restauranteCozinha" },
  },
  {
    name: "restauranteCardapioOnline",
    path: "/restauranteCardapioOnline",
    component: restauranteCardapioOnline,
    meta: { title: "Restaurante - Cardapio Online", permission: "restauranteCardapioOnline" },
  },
  {
    name: "restaurantePedidosOnline",
    path: "/restaurantePedidosOnline",
    component: restaurantePedidosOnline,
    meta: { title: "Restaurante - Pedidos Online", permission: "restaurantePedidosOnline" },
  },
  {
    name: "restauranteEntregasOnline",
    path: "/restauranteEntregasOnline",
    component: restauranteEntregasOnline,
    meta: { title: "Restaurante - Entregas Online", permission: "restauranteCardapioOnline" },
  },
  {
    name: "restauranteCaixaCheckout",
    path: "/restauranteCaixa/checkout/:atendimentoId",
    component: restauranteCheckout,
    meta: { title: "Restaurante - Checkout", permission: "restauranteCaixa" },
  },
  {
    name: "restauranteCaixaCheckoutComanda",
    path: "/restauranteCaixa/checkout-comanda/:codigoComanda?",
    component: restauranteCheckout,
    meta: { title: "Restaurante - Checkout", permission: "restauranteCaixa" },
  },
  {
    name: "restauranteMesasCheckout",
    path: "/restaurante/checkout/:atendimentoId",
    component: restauranteCheckout,
    meta: { title: "Restaurante - Checkout", permission: "restauranteCaixa" },
  },
];
